module.exports = __webpack_public_path__ + "images/homepage-top-categories-bg.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-top-categories-bg.png
// module id = 867
// module chunks = 0